import React, {useState, useEffect} from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DraggableModalDialog } from './DraggableModalDialog';

export interface ConfirmationDialogProps {
    showDialog: boolean,
    closeDialog: () => void,
    title?: string,
    okLabel?: string,
    cancelLabel?: string,
    onOk: () => void,
    onCancel?: () => void,
    variant?: "warning" | "danger" | "success" | "information",
    children?: React.JSX.Element
}

function ConfirmationDialog({ showDialog, closeDialog, title = undefined, okLabel = undefined, cancelLabel = undefined, onOk, onCancel, variant, children }: ConfirmationDialogProps) {

    const { t } = useTranslation();
    const onClickOk = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();

        onOk();
        closeDialog();
    }

    const onClickCancel = () => {
        if (onCancel) {
            onCancel();
        } else {
            closeDialog();
        }
    };

    const [titleVariant, setTitleVariant] = useState(variant ? `bg-${variant}` : undefined);
    useEffect(() => {
        if (variant) {
            setTitleVariant(`bg-${variant}`);
        }
    }, [variant]);

    return (
        <Modal dialogAs={DraggableModalDialog} show={showDialog} onHide={closeDialog} backdrop="static">
            <Modal.Header closeButton className={titleVariant}>
                {title &&
                    <Modal.Title>{title}</Modal.Title>
                }
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClickCancel}>
                    {cancelLabel ?? t("Application.Controls.Cancel")}
                </Button>
                <Button onClick={onClickOk}>
                    {okLabel ?? t("Application.Controls.Ok")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationDialog;